var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50019 21C3.22405 21 3.00019 21.2239 3.00019 21.5C3.00019 21.7761 3.22405 22 3.50019 22L21.3237 22C21.5999 22 21.8237 21.7761 21.8237 21.5C21.8237 21.2239 21.5999 21 21.3237 21L3.50019 21ZM12.4119 14.9412C12.3325 14.9412 12.2571 14.9251 12.1893 14.8961C12.1464 14.8779 12.1056 14.854 12.068 14.8246C12.055 14.8144 12.0425 14.8036 12.0305 14.7923L6.68623 9.81802C6.47739 9.62364 6.47739 9.30849 6.68623 9.11411C6.89507 8.91973 7.23366 8.91973 7.4425 9.11411L11.8772 13.2418L11.8772 2.49774C11.8772 2.22285 12.1166 2 12.4119 2C12.7073 2 12.9467 2.22285 12.9467 2.49774L12.9467 13.2418L17.3814 9.11411C17.5903 8.91973 17.9289 8.91973 18.1377 9.11411C18.3465 9.30849 18.3465 9.62364 18.1377 9.81802L12.7901 14.7954C12.7372 14.8446 12.676 14.8814 12.6106 14.9057C12.5492 14.9286 12.4821 14.9412 12.4119 14.9412Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDownload);
export default __webpack_public_path__ + "static/media/icn-download.f94b5a73.svg";
export { ForwardRef as ReactComponent };